
const baseGeneralUrl = "General"

  const endpoints = {
    getDopingsByUserTypeId:`${baseGeneralUrl}/GetDopingsByUserTypeId`,
   
  };
  
  export default endpoints;